export default "__VITE_ASSET__CUnxzD_P__"